'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentDataCreditNoteForm$$anon$7() {
}
export { $c_Lapp_data_AppDocumentDataCreditNoteForm$$anon$7 as $c_Lapp_data_AppDocumentDataCreditNoteForm$$anon$7 };
$p = $c_Lapp_data_AppDocumentDataCreditNoteForm$$anon$7.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$p.constructor = $c_Lapp_data_AppDocumentDataCreditNoteForm$$anon$7;
/** @constructor */
function $h_Lapp_data_AppDocumentDataCreditNoteForm$$anon$7() {
}
export { $h_Lapp_data_AppDocumentDataCreditNoteForm$$anon$7 as $h_Lapp_data_AppDocumentDataCreditNoteForm$$anon$7 };
$h_Lapp_data_AppDocumentDataCreditNoteForm$$anon$7.prototype = $p;
$p.a9 = (function(x) {
  return false;
});
$p.a8 = (function(x, default$1) {
  return (false ? x.Z() : default$1.h(x));
});
var $d_Lapp_data_AppDocumentDataCreditNoteForm$$anon$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentDataCreditNoteForm$$anon$7, "app.data.AppDocumentDataCreditNoteForm$$anon$7", ({
  AN: 1,
  h: 1,
  f: 1,
  g: 1,
  a: 1
}));
export { $d_Lapp_data_AppDocumentDataCreditNoteForm$$anon$7 as $d_Lapp_data_AppDocumentDataCreditNoteForm$$anon$7 };
//# sourceMappingURL=app.data.-App-Document-Data-Credit-Note-Form$$anon$7.js.map
